import React from "react";

import styled from "styled-components";
import { colors } from "@teamrota/rota-design";

// this file will be add to rota-library

const StyledMainButton = styled.button`
  width: ${({ size, variant }) => {
    const rightSize = {
      small: 80,
      medium: 142,
      large: 177
    };
    return variant === "text" ? "auto" : `${rightSize[size]}px`;
  }};
  height: 29px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  font-size: ${({ size }) => {
    const fontSize = {
      small: 12,
      medium: 14,
      large: 14
    };
    return `${fontSize[size]}px`;
  }};
  border-radius: ${({ variant }) => (variant === "text" ? 0 : "20px")};
  color: ${({ variant, color }) => {
    const variants = {
      secondary: colors.black,
      contained: colors.white
    };
    return variants[variant] || color || colors.rotaOrange;
  }};
  background: ${({ variant, color }) => {
    const variants = {
      secondary: colors.smokeGrey,
      contained: color || colors.rotaOrange,
      text: "transparent"
    };
    return variants[variant] || colors.white;
  }};
  border: 1.5px solid;
  border-color: ${({ variant, color }) => {
    const variants = {
      raised: colors.white,
      text: "transparent",
      secondary: colors.smokeGrey
    };
    return variants[variant] || color || colors.rotaOrange;
  }};
  border-bottom-color: ${({ variant, color }) =>
    variant === "text" && (color || colors.rotaOrange)};
  box-shadow: ${({ variant }) =>
    variant === "raised" ? "3px 3px 4px #99999940" : "none"};

  &:hover {
    background: ${({ variant, color }) => {
      const variants = {
        text: "transparent",
        secondary: colors.lightGrey
      };
      return variants[variant] || color || colors.orange;
    }};
    border: 1px solid;
    border-color: ${({ variant, color }) => {
      const variants = {
        text: "transparent",
        secondary: colors.lightGrey
      };
      return variants[variant] || color || colors.orange;
    }};
    border-bottom-color: ${({ variant, color }) =>
      variant === "text" && (color || colors.orange)};
    color: ${({ variant, color }) => {
      const variants = {
        text: color || colors.orange,
        secondary: colors.darkGrey
      };
      return variants[variant] || colors.smokeGrey;
    }};
    box-shadow: ${({ variant }) =>
      variant === "raised" ? "3px 3px 4px #70707080" : "none"};
  }
  &:active {
    background: ${({ variant, color }) => {
      const variants = {
        text: "transparent",
        secondary: colors.grey
      };
      return variants[variant] || color || colors.fireOrange;
    }};
    border: 1px solid;
    border-color: ${({ variant, color }) => {
      const variants = {
        text: "transparent",
        secondary: colors.grey
      };
      return variants[variant] || color || colors.fireOrange;
    }};
    border-bottom-color: ${({ variant, color }) =>
      variant === "text" && (color || colors.fireOrange)};
    color: ${({ variant, color }) => {
      const variants = {
        text: color || colors.fireOrange,
        secondary: colors.black
      };
      return variants[variant] || colors.white;
    }};

    box-shadow: ${({ variant }) =>
      variant === "raised" ? "1px 1px 4px #70707040" : "none"};
  }
  &:disabled {
    color: ${({ theme }) => theme.neutral.main};
    background: ${({ variant }) => {
      const variants = {
        outlined: colors.white,
        contained: colors.grey,
        text: colors.white
      };
      return variants[variant] || colors.smokeGrey;
    }};
    border: 1px solid;
    border-color: ${({ variant, theme }) => {
      const variants = {
        secondary: colors.smokeGrey,
        raised: colors.smokeGrey,
        text: `transparent transparent ${theme.neutral.main} transparent`
      };
      return variants[variant] || colors.grey;
    }};
    box-shadow: ${({ variant }) =>
      variant === "raised" ? "3px 3px 4px #99999940" : "none"};
  }
`;

const RotaButton = ({
  onClick,
  children,
  variant = "contained",
  size = "medium",
  color,
  ...props
}) => {
  return (
    <StyledMainButton
      color={color}
      onClick={onClick}
      {...props}
      variant={variant}
      size={size}
    >
      {children}
    </StyledMainButton>
  );
};

export default RotaButton;
